import * as Constants from '../constants';

import * as BlockSDK from '../../utilities/blockSdkHelper';

import { default as Endpoint } from '../../api/Endpoint';

export function requestSaveBlock() {
  return {
    type: Constants.REQUEST_SAVE_BLOCK_DATA
  };
}
export function receiveSaveBlock(json, error) {
  return {
    type: Constants.RECEIVE_SAVE_BLOCK_DATA,
    data: json,
    error
  };
}

export function requestMessageBlocks() {
  return {
    type: Constants.REQUEST_MESSAGE_BLOCKS
  };
}
export function receiveMessageBlocks(json, error) {
  return {
    type: Constants.RECEIVE_MESSAGE_BLOCKS,
    data: json,
    error
  };
}

export function requestBlockDistribution() {
  return {
    type: Constants.REQUEST_BLOCK_DISTRIBUTION
  };
}
export function receiveBlockDistribution(json, error) {
  return {
    type: Constants.RECEIVE_BLOCK_DISTRIBUTION,
    data: json,
    error
  };
}

export function getAssetDistributionByBlock(blockId, options = {}) {
  const path = `ecs/api/block/${blockId}/distribution`;
  return new Endpoint(path, requestBlockDistribution, receiveBlockDistribution)
    .withOptions(options)
    .call();
}

export function getMessageBlocks(messageId, options = {}) {
  const path = `ecs/api/block?message_id=${messageId}`;
  return new Endpoint(path, requestMessageBlocks, receiveMessageBlocks)
    .withMethod('GET')
    .withOptions(options)
    .call();
}

export function saveBlock(block, options = {}) {
  const path = 'ecs/api/block';
  return new Endpoint(path, requestSaveBlock, receiveSaveBlock)
    .withMethod('POST')
    .withBody(JSON.stringify(block))
    .withOptions(options)
    .call();
}

export function requestBlockData() {
  return { type: Constants.REQUEST_BLOCK_DATA, dataType: 'data' };
}

export function receiveBlockData(data) {
  return {
    type: Constants.RECEIVE_BLOCK_DATA,
    data,
    dataType: 'data'
  };
}

export function getBlockDataFromSdk() {
  return dispatch => {
    dispatch({ type: Constants.REQUEST_BLOCK_DATA, dataType: 'data' });

    return BlockSDK.getBlockData().then(data => {
      dispatch({
        type: Constants.RECEIVE_BLOCK_DATA,
        data,
        dataType: 'data'
      });
    });
  };
}

export function getCentralDataFromSdk() {
  return dispatch => {
    dispatch({ type: Constants.REQUEST_BLOCK_DATA, dataType: 'centralData' });

    return BlockSDK.getCentralData().then(centralData => {
      dispatch({
        type: Constants.RECEIVE_BLOCK_DATA,
        centralData,
        dataType: 'centralData'
      });
    });
  };
}

export function getViewDataFromSdk() {
  return dispatch => {
    dispatch({ type: Constants.REQUEST_BLOCK_DATA, dataType: 'viewData' });

    return BlockSDK.getView().then(viewData => {
      dispatch({
        type: Constants.RECEIVE_BLOCK_DATA,
        viewData,
        dataType: 'viewData'
      });
    });
  };
}

export function getUserDataFromSdk() {
  return dispatch => {
    dispatch({ type: Constants.REQUEST_USER_DATA });

    return BlockSDK.getUserData().then(data => {
      dispatch({
        type: Constants.RECEIVE_USER_DATA,
        data
      });
    });
  };
}

const script = `
%%[
/*
  Einstein Content Selection -- Modify At Your Own Risk
*/

VAR @subscriber_id, @subscriber_key, @mid, @mid_dash, @hash_subid, @hash_subkey, @hash_email
SET @subscriber_id = SubscriberID
SET @subscriber_key = lowercase(_subscriberkey)
SET @email = emailname_
SET @mid = memberid
SET @mid_dash = Concat(@mid, "-")
SET @hash_subid = SHA256(Concat(@mid_dash,@subscriber_id))
SET @hash_subkey = SHA256(Concat(@mid_dash,@subscriber_key))
SET @hash_email = SHA256(Concat(@mid_dash,@email))
IF EMPTY(@seed) THEN
  VAR @seed
  SET @seed = Format(now(), "ddHHmmss")
ENDIF
]%%

`;

const endComment = `
%%[
/*
  Einstein Content Selection -- End
*/
]%%
`;

function querystring() {
  const map = {
    subscriber_id: '%%=v(@hash_subid)=%%',
    subscriber_key: '%%=v(@hash_subkey)=%%',
    context: '%%_messagecontext%%',
    email: '%%=v(@hash_email)=%%',
    job_id: '%%jobid%%',
    batchId: '%%_JobSubscriberBatchID%%',
    send_date: '%%xtyear%%-%%xtmonthnumeric%%-%%xtday%%',
    seed: '%%=v(@seed)=%%'
  };

  return Object.entries(map)
    .map(e => `${e[0]}=${e[1]}`)
    .join('&');
}

function getAlignment(options) {
  if (options?.centerBlockInTable) {
    return 'center';
  } else if (options?.alignment) {
    return options?.alignment;
  } else {
    return 'left';
  }
}

function generateBlockHtmlContent(page, options = {}) {
  const base_url = window.location.host;
  const path = `/einstein/api/block/${page.id}/selection`;
  const url = `https://${base_url}${path}?${querystring()}`;
  const imageUrl = `${url}&image=true`;
  const trackConversion = options?.conversion ? ' conversion=true' : '';
  const height = options?.height || 'auto';
  const width = options?.width || 'auto';
  const maxWidth = options?.maxWidth || '100%';
  const altText = options?.altText || '';
  const alignment = getAlignment(options);

  const content = `
      <table align="${alignment}" className="container" border="0" cellSpacing="0" cellPadding="0">
        <tr>
          <td align="${alignment}" valign="top" style="padding:0;">
            <a href="${url}" alias="ECSlink_alias"${trackConversion}>
              <img src="${imageUrl}" alt="${altText}" width="${width}" height="${height}" style="max-width: ${maxWidth}">
            </a>
          </td>
        </tr>
      </table>`;
  return `${script}${content}${endComment}`;
}

export function setSuperContentInSdk(content) {
  return dispatch => {
    dispatch({
      type: Constants.REQUEST_SET_CONTENT,
      content
    });

    return BlockSDK.setSuperContent(content).then(() => {
      dispatch({
        type: Constants.RECEIVE_SET_CONTENT,
        superContent: content
      });
    });
  };
}

export function setContentInSdk(page, options = {}) {
  const contentElement = generateBlockHtmlContent(page, options);

  return dispatch => {
    dispatch({ type: Constants.REQUEST_SET_CONTENT, content: contentElement });

    return BlockSDK.setContent(contentElement).then(() => {
      dispatch({
        type: Constants.RECEIVE_SET_CONTENT,
        content: contentElement
      });
    });
  };
}

export function saveBlockDataInSdk(data) {
  return dispatch => {
    dispatch({
      type: Constants.REQUEST_SAVE_BLOCK_SDK_DATA,
      data,
      dataType: 'data'
    });

    return BlockSDK.saveBlockData(data).then(() => {
      dispatch({
        type: Constants.RECEIVE_SAVE_BLOCK_SDK_DATA,
        data,
        dataType: 'data'
      });
    });
  };
}

export function saveCentralDataInSdk(data) {
  return dispatch => {
    dispatch({
      type: Constants.REQUEST_SAVE_BLOCK_SDK_DATA,
      data,
      dataType: 'centralData'
    });

    return BlockSDK.saveCentralData(data).then(() => {
      dispatch({
        type: Constants.RECEIVE_SAVE_BLOCK_SDK_DATA,
        data,
        dataType: 'centralData'
      });
    });
  };
}
